const BlogPostContent = ({ content }) => (
  <article className="prose prose-lg max-w-none" data-testid="blog-post-content">
    {content.split('\n').map((line, i) => {
      const trimmed = line.trim();
      const key = `${i}-${trimmed.slice(0, 24)}`;
      if (!trimmed) return <div key={key} className="h-4" />;
      if (trimmed.startsWith('## ')) {
        return (
          <h2
            key={key}
            className="text-xl sm:text-2xl font-bold text-[#0B2A57] mt-10 mb-4"
            style={{ fontFamily: 'Cabinet Grotesk' }}
          >
            {trimmed.replace('## ', '')}
          </h2>
        );
      }
      if (trimmed.startsWith('**') && trimmed.endsWith('**')) {
        return (
          <h3 key={key} className="text-base font-bold text-[#0B2A57] mt-6 mb-2">
            {trimmed.replace(/\*\*/g, '')}
          </h3>
        );
      }
      if (trimmed.startsWith('**') && trimmed.includes('** —')) {
        const parts = trimmed.split('** —');
        return (
          <p key={key} className="text-sm text-[#6B7280] leading-relaxed mb-3">
            <strong className="text-[#0B2A57]">{parts[0].replace(/\*\*/g, '')}</strong>
            {' '}&mdash;{parts[1]}
          </p>
        );
      }
      if (trimmed.startsWith('- ')) {
        return (
          <div key={key} className="flex items-start gap-2 mb-2 ml-4">
            <span className="w-1.5 h-1.5 rounded-full bg-[#1E3D66] flex-shrink-0 mt-2" />
            <span className="text-sm text-[#6B7280] leading-relaxed">{trimmed.replace('- ', '')}</span>
          </div>
        );
      }
      if (/^\d+\./.test(trimmed)) {
        return (
          <div key={key} className="flex items-start gap-3 mb-2 ml-4">
            <span className="text-sm font-semibold text-[#0B2A57] flex-shrink-0">{trimmed.match(/^\d+\./)[0]}</span>
            <span className="text-sm text-[#6B7280] leading-relaxed">{trimmed.replace(/^\d+\.\s*/, '')}</span>
          </div>
        );
      }
      return (
        <p key={key} className="text-sm text-[#6B7280] leading-relaxed mb-4">
          {trimmed}
        </p>
      );
    })}
  </article>
);

export default BlogPostContent;
